import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  ScrollView,
  StyleSheet,
  View,
  Text,
  TouchableHighlight,
} from './base_components';

const styles = StyleSheet.create({
  tabBar: {
    marginTop: '1rem',
    alignSelf: 'stretch',
    borderBottomWidth: 1,
    borderBottomColor: 'var(--tabbar-line-color)',
    flexDirection: 'column',
  },
  scroller: {
    alignSelf: 'stretch',
    flexDirection: 'row',
    '@media (min-width: 800px)': {
      overflow: 'hidden',
    },
  },
  scrollerInner: {
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  tab: {
    height: '3rem',
    alignSelf: 'stretch',
    flexDirection: 'row',
  },
  highlight: {
    alignSelf: 'stretch',
    flexDirection: 'column',
    borderRadius: '0.5rem',
    overflow: 'hidden',
  },
  tabInner: {
    paddingLeft: '2rem',
    paddingRight: '2rem',
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  textView: {
    flex: 1,
    alignSelf: 'stretch',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    color: 'var(--tabbar-text)',
    fontSize: '1.4rem',
    fontWeight: '500',
  },
  selectedText: {
    color: 'var(--tabbar-selected-text)',
    fontWeight: '700',
  },
  line: {
    alignSelf: 'stretch',
    height: 2,
  },
  selectedLine: {
    backgroundColor: 'var(--tabbar-selected-bg)',
  },
});
type Props = {
  style?: any;
  value?: string;
  list: any[];
  onChange?: (value: string) => void;
};
export default function TabBar(props: Props) {
  const { style, value, list, onChange } = props;
  const location = useLocation();
  return (
    <View style={[styles.tabBar, style]}>
      <ScrollView
        style={styles.scroller}
        contentContainerStyle={styles.scrollerInner}
        horizontal={true}
      >
        {list.map((item, i) => {
          const selected =
            item.value === value || item.url === location.pathname;
          return (
            <Tab
              key={i}
              text={item.text}
              value={item.value}
              url={item.url}
              last={i === list.length - 1}
              selected={selected}
              onChange={onChange}
            />
          );
        })}
      </ScrollView>
    </View>
  );
}
function Tab(props: any) {
  const { text, value, url, selected, onChange } = props;
  const navigate = useNavigate();

  function _onPress() {
    if (onChange) {
      onChange(value);
    } else {
      navigate(url);
    }
  }
  return (
    <View style={styles.tab}>
      <TouchableHighlight
        style={styles.highlight}
        underlayColor='rgba(0,0,0,0.1)'
        onPress={_onPress}
      >
        <View style={styles.tabInner}>
          <View style={styles.textView}>
            <Text style={[styles.text, selected ? styles.selectedText : null]}>
              {text}
            </Text>
          </View>
          <View style={[styles.line, selected ? styles.selectedLine : null]} />
        </View>
      </TouchableHighlight>
    </View>
  );
}
